export const ORGANIZATIONS = 'organizations';
export const PROJECTS = 'projects';
export const USERS = 'users';
export const TRANSLATIONS = 'translations';
export const TRANSLATION_IMAGES = 'translation-images';
export const INVITATIONS = 'invitations';